import * as React from 'react';
import { Page, Text, Document, StyleSheet, View } from '@react-pdf/renderer';
import Acknowledgement from 'src/models/leasing/Acknowledgement';
import SignatureBlock from 'src/models/leasing/SignatureBlock';
import SaltwerxBrineLeaseProps from 'src/models/leaseTemplateProps/SaltwerxBrineLeaseProps';

const styles = StyleSheet.create({
    page: {
        backgroundColor: '#FFFFFF',
        paddingTop: '1in',
        paddingBottom: '1in',
        paddingHorizontal: '1in',
        fontFamily: 'Helvetica'
    },
    pageNumbers: {
        position: 'absolute',
        bottom: 20,
        left: 0,
        right: 0,
        textAlign: 'center',
        fontSize: 10,
        color: '#8e9094',
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
    },
    bold: {
        fontFamily: 'Helvetica-Bold',
        fontWeight: 'bold'
    },
    fontNormal: {
        fontFamily: 'Helvetica',
        fontSize: '9.5pt',
    },
    font9pt: {
        fontFamily: 'Helvetica',
        fontSize: '9pt',
        lineHeight: 1.25,
    },
    noticeHeadingSize: {
        fontSize: '12pt',
    },
    mt1: {
        marginTop: 10,
    },
    mt2: {
        marginTop: 20,
    },
    mt3: {
        marginTop: 30,
    },
    mt4: {
        marginTop: 40,
    },
    mb1: {
        marginBottom: 10,
        textAlign: 'justify'
    },
    mb2: {
        marginBottom: 20
    },
    mb3: {
        marginBottom: 30
    },
    mb4: {
        marginBottom: 40
    },
    center: {
        textAlign: 'center',
    },
    indent: {
        textIndent: '.45in',
    },
    negativeindent: {
        textIndent: '-.45in',
    },
    text: {
        textAlign: 'justify',
    },
    sbTitle: {
        textAlign: 'center',
        marginBottom: 10,
    },
    underlined: {
        textDecoration: 'underline',
    },
    mailingInfo: {
        fontSize: 10,
        fontFamily: 'Helvetica',
    },
    acknowledgementHeading: {
        textAlign: 'center',
        fontSize: '10pt',
        fontWeight: 'bold',
    },
    exhibitHeading: {
        textAlign: 'center',
        fontSize: '12pt',
        fontWeight: 'bold',
    },
    leaseHeading: {
        fontSize: 18,
        textAlign: 'center',
        fontFamily: 'Helvetica-Bold',
        fontWeight: 'extrabold'
    },
    doubleLines: {
        borderTop: '1px solid black',
        borderBottom: '1px solid black',
    },
    h2: {
        fontSize: 14,
    },
    firstLvl: {
        marginLeft: 20,
    },
    secondLvl: {
        marginLeft: 54,
    },
    thirdLvl: {
        marginLeft: 70,
    },
    fourthLvl: {
        marginLeft: 86,
    },
});

export interface IAethonLeaseStateProps {
    leaseProps?: SaltwerxBrineLeaseProps;
}

export default class SaltwerxBrineLeaseTemplate extends React.Component<IAethonLeaseStateProps> {
    additionalProvisions = () => {
        return this.props.leaseProps?.additionalProvisions?.map((ap: string, index: number) => {
            return (<Text key={index} style={[{ fontSize: '10pt' }, styles.mt2, styles.text]}>{ap}</Text>);
        });
    };

    adhocProvisions = () => {
        const adHocClauses = this?.props?.leaseProps?.adHocClauses;

        if (this.props?.leaseProps?.adHocClauses?.length > 0) {
            return adHocClauses.map((lc: string, index: number) => {
                return (<Text key={index} style={[{ fontSize: '10pt' }, styles.mt2, styles.text]}>{lc}</Text>);
            });
        }
        return <></>;
    };

    displaySignatureBlocks = () => {
        return this.props?.leaseProps
            ? this.props?.leaseProps?.acknowledgements?.map((la: Acknowledgement) => {
                return (
                    la.signatureBlocks?.length > 0 &&
                    la.signatureBlocks.map((sb: SignatureBlock, index: number) => {
                        return (
                            <View key={index} wrap={false} style={{ marginRight: 5 }}>
                                {!!sb.title && sb?.title?.length > 0 && (
                                    <Text style={[{ fontSize: '10pt' }, styles.mt3, styles.text, styles.bold]}>{sb?.title}</Text>
                                )}
                                {/* <Text style={[{ fontSize: '10pt' }, styles.mt2, styles.text]}>Lessor:</Text> */}
                                <Text style={[{ fontSize: '10pt' }, styles.mt4, styles.text, styles.bold]}>
                                    ____________________________________
                                </Text>
                                <Text style={[{ fontSize: '10pt' }, styles.text, styles.bold]}>{sb.ownerName}</Text>
                            </View>
                        );
                    })
                );
            })
            : [];
    };

    displayAcknowledgements = () => {
        return this.props?.leaseProps
            ? this.props?.leaseProps?.acknowledgements?.map((la: Acknowledgement, index: number) => {
                return (
                    <View key={index} wrap={false}>
                        <Text style={[{ fontSize: '10pt' }, styles.mt3, styles.text]}>{la.text}</Text>
                    </View>
                );
            })
            : [];
    };

    // signatureBlocks = (leaseValues: AnyObject) => {
    //     return <SignatureBlockManager leaseValues={leaseValues} styles={styles} />;
    // };

    // tslint:disable: max-line-length
    render() {
        // const firstIncludedTract = leaseValues?.tracts?.find((tract: AnyObject) => tract.includeTract === true);
        // const totalGrossAcres = leaseValues?.tracts?.reduce((acc: number, tract: AnyObject) => {
        //     if (tract.includeTract === true) {
        //         let tempGrossAcres = parseFloat(tract.grossAcres) || 0;
        //         return acc + tempGrossAcres;
        //     } else {
        //         return acc;
        //     }
        // }, 0);

        return (
            <Document>
                <Page size="LEGAL" style={styles.page}>
                    <Text style={[styles.leaseHeading, styles.mb3, { fontWeight: 'extrabold' }]}>BRINE LEASE</Text>
                    <View>
                        <Text style={[styles.fontNormal, styles.text, styles.indent]}>THIS AGREEMENT, entered into this {this.props.leaseProps.leaseDateDo} day of {this.props.leaseProps.leaseDateMonthName}, {this.props.leaseProps.leaseDateYear}, and to become effective as
                            of {this?.props?.leaseProps?.effectiveDateFull} between {this?.props?.leaseProps?.ownersOnDocument} herein called Lessor (whether one or more), whose address is  {this?.props?.leaseProps?.ownersAddressOnDocument}
                            and Saltwerx LLC, whose address is 22777 Springwoods Village Parkway, Spring, TX 77389-1425 , herein called Lessee.
                        </Text>
                    </View>

                    <View style={[styles.fontNormal, styles.center]}>
                        <Text style={[styles.fontNormal, styles.center, styles.mt1, styles.mb1, { textAlign: 'center'}]}>WITNESSETH:</Text>
                    </View>

                    <View style={{ flexDirection: 'row' }} wrap={false}>

                        <Text style={[styles.fontNormal, { width: '7%' }]}>§1.</Text>

                        <Text style={[styles.fontNormal, { textAlign: 'justify', width: '93%' }]}>
                            Lessor, in consideration of Ten Dollars ($10.00) cash in hand paid, and other valuable consideration, the receipt of which
                            is hereby acknowledged, of the rental and of the royalty herein provided and of the agreements of Lessee herein contained, hereby
                            grants, leases, and lets exclusively to Lessee for the purpose of investigating, exploring, prospecting, drilling for and producing
                            brine (as defined in Article 15); conducting exploration, geologic and geophysical tests and surveys; producing and removing brine by
                            drainage, extraction, forced subterranean movement, pumping or other means; injecting gas, water, brine and other fluids and air into
                            subsurface strata; laying pipelines, establishing and utilizing facilities for the disposition of brine; building roads, bridges, tanks,
                            telephone lines, power lines, power stations and other structures thereon and on, over, and across land owned or claimed by Lessor adjacent
                            or contiguous thereto necessary or desirable to Lessee in operations to produce, save, store, take care of, measure, treat. transport and own
                            said brine; for an appliances or structures, equipment easements, and privileges which may be necessary, useful, or convenient to or used in
                            connection with any such operations conducted by Lessee thereon or on land pooled or unitized therewith or on any contiguous or adjacent land,
                            the following described land in Miller County, State of Arkansas ; to-wit:
                        </Text>
                    </View>
                    <View style={[{ flexDirection: 'row' }]}>
                    {this?.props?.leaseProps?.legalDescription?.length > 1000 &&
                        <>
                            <Text style={[styles.fontNormal]}>See Exhibit A</Text>
                        </>
                    }
                    {this?.props?.leaseProps?.legalDescription?.length < 1000 &&
                        <>
                            <Text style={[styles.fontNormal, { width: '7%' }]} />
                            <Text style={[styles.mt1, styles.bold, styles.mb1, { textAlign: 'justify', width: '93%', fontSize: '9.5pt' }]}>
                                {this?.props?.leaseProps?.legalDescription}
                            </Text>
                        </>
                    }
                    </View>
                    <View style={[styles.mb1, { flexDirection: 'row' }]}>
                        <Text style={[styles.fontNormal, { width: '7%' }]} />
                        <Text style={[styles.fontNormal, { textAlign: 'justify', width: '93%' }]}>
                            This lease also covers and includes all land owned by Lessor adjacent, or contiguous to the land particularly described above. For the
                            purpose of calculating rental and royalty payments hereunder, said land is estimated to contain <Text style={styles.bold}>{this?.props?.leaseProps?.originalGrossAcres}</Text> acres, whether it contains
                            more or less.
                        </Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]} wrap={false}>
                        <Text style={[styles.fontNormal, { width: '7%' }]}>§2.</Text>
                        <Text style={[styles.fontNormal, { textAlign: 'justify', width: '93%' }]}>
                            Lessor hereby acknowledges receipt of all rentals as cited in §4 of this Lease for the first through the fourth anniversary dates, making this
                            Lease a {this?.props?.leaseProps.primaryRentalTerm}-{this?.props?.leaseProps.primaryRentalUnit} paid-up Rental Lease as to rentals for the first five years. Whether or not any reduction in rental and/or royalty payments shall
                            have previously been made, this Lease, without further evidence thereof, shall immediately attach to and affect any and all rights, title, and
                            interests in the land and brine interest covered by this Lease, including reversionary brine interest, hereafter acquired by or inuring to the
                            Lessor and Lessor's successors and assigns. If any reduction in rentals or royalties shall have previously been made, such additional interest
                            shall be considered in the computation of rentals or royalties starting with the rental or royalty payment date next ensuing more than
                            forty-five (45) days after receipt by Lessee of written notice from Lessor of the acquisition and extent of such additional interest and the
                            manner of such acquisition.
                        </Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]} wrap={false}>
                        <Text style={[styles.fontNormal, { width: '7%' }]}>§3.</Text>
                        <Text style={[styles.fontNormal, { width: '93%' }]}>
                            This Lease, subject to the right of Lessee to cancel and surrender it insofar as it covers all or any part of the above-mentioned land as
                            hereinafter provided, shall remain in full force and effect for a term of FIVE years from the date hereinbefore first written and as long
                            thereafter as any of the payments specified in §4 hereof continue to be made.
                        </Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]} wrap={false}>
                        <Text style={[styles.fontNormal, { width: '7%' }]}>§4.</Text>
                        <Text style={[styles.fontNormal, { width: '93%' }]}>
                            As additional consideration for this Lease, Lessee shall pay as rental to Lessor, on or before each anniversary date of this Lease a sum to be
                            ascertained by multiplying the number of acres set out in §1 above, as follows: (1) by One Dollar ($1.00) for each of the first through the
                            fourth anniversary dates hereof, (2) by Ten Dollars ($10.00) for each of the fifth through the fourteenth anniversary dates hereof, and (3) by
                            Twenty Five Dollars ($25.00) for each of the remaining anniversary dates hereof, provided, however, that, if more than sixty (60) days prior to
                            any such anniversary date hereof Lessee has engaged in the production of brine for the purpose of extracting minerals therefrom or injection of
                            brine from or into any well located on the land covered hereby or on acreage pooled therewith (or any part thereof) or within one-half (1/2)
                            mile of the land covered by this Lease, which brine is not produced incidental to the production of oil, gas or distillate or in the testing of
                            the capacity of a well to produce brine, then, instead of payments as rental, each Lessor shall be paid thereafter a sum either in lieu of
                            royalty or as shut-in royalty, such sum, in case of payments in lieu of royalty, being ascertained by multiplying the number of acres set out
                            above in §1 hereof by Thirty-Two Dollars ($32.00) and such sum, in case of payments of shut-in royalty, being ascertained in accordance with
                            the provisions of §6 hereof, and provided, further, that if Lessor owns less than the entire undivided interest in all or any portion of the
                            land or mineral and royalty interest relating thereto (whether such interest is herein specified or not) then each payment to be made under
                            this §4 may be reduced to the proportion which the interest, if any, herein covered by this Lease bears to the entire undivided interest therein.
                        </Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]}>
                    <Text style={[styles.fontNormal, { width: '7%' }]} />
                        <Text style={[styles.fontNormal, { width: '93%' }]}>It is further agreed, that:</Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]} wrap={false}>
                        <Text style={[styles.fontNormal, { textIndent: '.45in', width: '15%'}]}>(a)</Text>

                        <Text style={[styles.fontNormal, { width: '85%' }]}>Lessee's right to make any annual payment as above set out shall terminate at the later in time of (i) the end of twenty-five (25)
                            years from the date of this lease or (ii) at the end of any annual period of this lease during which Lessee shall not have been in actual
                            production or injection of brine either from or into land covered hereby or acreage pooled therewith (or some part thereof or production
                            from or injection into a well situated within one-half mile (1/2) of land covered by this Lease); and such right by Lessee to make such
                            annual payments will then continue only so long thereafter as such production or injection shall be continued or so long as shut-in royalty
                            is paid pursuant to §6 hereof.
                        </Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]} wrap={false}>
                        <Text style={[styles.fontNormal, { textIndent: '.45in', width: '15%'}]}>(b)</Text>

                        <Text style={[styles.fontNormal, { width: '85%' }]}>
                            If the mineral or royalty interest of any person named as Lessor under the land covered by this lease has heretofore been reduced
                            by the conveyance of a nonparticipating mineral interest or nonparticipating royalty interest by him, or by his predecessor in title,
                            each payment to be made under the provisions of this §4 to that person named as Lessor may be reduced proportionately.
                        </Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]} wrap={false}>
                        <Text style={[styles.fontNormal, { textIndent: '.45in', width: '15%'}]}>(c)</Text>

                        <Text style={[styles.fontNormal, { width: '85%' }]}>
                            Each owner of such nonparticipating mineral interest, or nonparticipating royalty interest, executing this agreement, or a counterpart
                            thereof, agrees to accept such payment in lieu of royalty on brine produced or removed from the land covered by this lease and in
                            satisfaction of damages, if any, which he may sustain by drainage or removal of brine from the land covered by this lease.
                        </Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]} wrap={false}>
                        <Text style={[styles.fontNormal, { textIndent: '.45in', width: '15%'}]}>(d)</Text>

                        <Text style={[styles.fontNormal, { width: '85%' }]}>
                            In lieu of making any payment to Lessor under the provisions of this §4, Lessee may pay or tender for deposit to the credit of
                            Lessor at _____________________________________ the sum so payable, which shall, for all purposes of this lease, be considered
                            to be a payment to Lessor. If at the time of such deposit any person hereinbefore named as Lessor is dead or is an incompetent such
                            deposit in the name of the deceased or the incompetent shall, for all purposes, be binding upon the heirs, devisees, executor or
                            administrator of the deceased or upon such incompetent or the guardian of the person or of the estate of the incompetent.
                            Should the bank named, or any depository subsequently named by Lessor, fail or liquidate, or if it should for any reason fail or
                            refuse to accept the check or draft of Lessee tendered in payment of any sum payable under the provisions of this §4, the attempted
                            payment in the manner hereinbefore provided shall not thereby be rendered ineffective, nor shall Lessee be in default for failure to
                            pay the sum involved until thirty (30) days after such Lessor shall have furnished to Lessee a recordable instrument naming a new
                            depository.  The failure to pay any such sum so due shall not give Lessor the right to cancel this lease as to any land covered by
                            this lease but shall only entitle the Lessor to recover from Lessee the sum so due.
                        </Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]} wrap={false}>
                        <Text style={[styles.fontNormal, { textIndent: '.45in', width: '15%'}]}>(e)</Text>

                        <Text style={[styles.fontNormal, { width: '85%' }]}>
                            Lessee, or any assignee or sublessee, may at any time, and from time to time, execute and file for record in said county, a release of
                            this Lease insofar as it affects all or any part or parts of the land covered by this Lease, and thereby be relieved, as to the land with
                            respect to which this Lease has been released, of any and all obligations of this Lease not then accrued. Without impairment of Lessee's
                            right to release said land or any part thereof and be thereby relieved of any liability therefor, it is agreed that Lessee shall nevertheless
                            be required to continue to make the annual payments in lieu of royalty or as shut-in royalty above set out for any and all acreage covered
                            hereby and situated within one-half (1/2) mile of any of Lessee's wells from which brine is being produced or into which brine is being
                            injected so long as such production or injection by Lessee shall be continued. Upon the filing of any such release, each payment shall be
                            reduced in the same proportion as Lessor's interest in the number of acres of land as to which this lease has been released bears to Lessor's
                            interest in the total number of acres stated in the foregoing §1.
                        </Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]} wrap={false}>
                        <Text style={[styles.fontNormal, { width: '7%' }]}>§5.</Text>
                        <Text style={[styles.fontNormal, { width: '93%' }]}>
                            Lessee shall have the right to use, free of cost, fresh water produced from the leased premises, excepting water produced from
                            a well of Lessor, for any of the operations of Lessee on the leased premises.
                        </Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]} wrap={false}>
                        <Text style={[styles.fontNormal, { width: '7%' }]}>§6.</Text>
                        <Text style={[styles.fontNormal, { width: '93%' }]}>
                            No royalty or payment, other than the payment provided in §4, shall be payable by Lessee to Lessor with respect to brine produced or removed
                            from the leased premises or with respect to any product, products, or minerals extracted from such brine by Lessee, or with respect to brine
                            produced from the leased premises, nor shall Lessee in any event be liable to Lessor for failure to protect the leased premises from drainage
                            or removal of brine and its contents. The sums payable to Lessor under the provisions of the foregoing §4 are to be made by Lessee in lieu of
                            any royalty with respect to brine produced or removed from the leased premises and any product or products extracted from the brine and in
                            complete compensation for any drainage or removal of brine from the land hereinbefore mentioned. The parties hereto agree that the annual in
                            lieu of royalty specified in §4 hereof shall be adjusted annually effective June 1, 1996, in the same manner as is provided by Act 1287 of the
                            1995 General Assembly of the State of Arkansas which amended Ark. Stat. Ann.§ 15-76-315. Notwithstanding any other provision hereof relating
                            to rental, royalty, or payments in lieu of royalty, if Lessee at any time or times suspends all production or injection of brine
                            (including its component parts) from or into the land covered hereby or acreage pooled therewith (of any part thereof) or from or into wells
                            located within one-half (1/2) mile of the land covered hereby, for any period of twelve (12) consecutive months prior to sixty (60) days prior
                            to any anniversary date of this Lease, then, provided Lessee pays to Lessor (in the manner specified above in §4) on or before such anniversary
                            date as shut-in royalty a sum to be ascertained by multiplying the number of acres set out in §1 hereof by Ten ($10.00) Dollars, this Lease
                            shall continue and remain in full force and effect without the obligation by Lessee to make any other payment under the aforesaid §4 hereof,
                            provided, however, that in no event may Lessee make such shut-in royalty payments continuously for a period in excess of three (3) consecutive
                            years.
                        </Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]} wrap={false}>
                        <Text style={[styles.fontNormal, { width: '7%' }]}>§7.</Text>
                        <Text style={[styles.fontNormal, { width: '93%' }]}>
                            Lessee shall have the right to drill, complete, recomplete, deepen, and operate a well or wells for the production of brine from any
                            horizon under the land covered by this lease, or for the injection of brine produced by Lessee from land covered by this lease or from
                            any other land into any horizon which lies below the depth of <Text style={[{ fontFamily: 'Helvetica-Bold' }]}>4,000 feet subsurface</Text> under the land covered by this lease.
                        </Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]} wrap={false}>
                        <Text style={[styles.fontNormal, { width: '7%' }]}>§8.</Text>
                        <Text style={[styles.fontNormal, { width: '93%' }]}>
                            Lessee, at its option, is hereby given the right and power without any further approval from Lessor, at any time and from time to
                            time, to pool or unitize the land or interests therein covered by this lease or any portion thereof with other land, lease, leases
                            or interests therein in the vicinity thereof when in Lessee's judgment it is necessary or advisable to do so in order to properly
                            explore or develop or operate said leased premises or to comply with the orders, rules and regulations of any Regulatory Body of
                            the State of Arkansas or the United States having jurisdiction. The term “Regulatory Body” shall include any governmental officer,
                            tribunal, or group (civil or military) issuing orders governing the drilling of wells or the production of minerals. Such pooling
                            shall be of tracts which will form a reasonably compact (but not necessarily contiguous) body of land for each unit, and the unit
                            or units so created shall not exceed substantially three thousand two hundred (3,200) acres for each well for brine exploration,
                            production or injection, plus a tolerance of ten percent  (10%) thereof in each instance, unless a larger spacing pattern or larger
                            drilling or production units (including a field or pool unit) shall have been fixed and established by an order of a Regulatory Body
                            of the State of Arkansas or of the United States, in which event the unit or units shall be the same as fixed by said order. Lessee
                            shall execute and file for record in the appropriate Records of the County in which the land and/or mineral interest herein leased
                            is situated a declaration describing the pooled acreage, and, upon such filing, the unit or units shall thereby become effective;
                            except that when a unit is created by order of a Regulatory Body the pooling shall be effective as of the effective date of such order,
                            and no declaration shall be required in connection therewith.
                        </Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]} wrap={false}>
                        <Text style={[styles.fontNormal, { width: '7%' }]}>§9.</Text>
                        <Text style={[styles.fontNormal, { width: '93%' }]}>
                            With regard to the payments in lieu of royalty as provided in §4 hereof, payments shall continue to be made upon an acreage basis and
                            specifically not based upon the proportionate part of production from any pooled unit. Any unit formed by Lessee hereunder may be
                            created either prior to or during or after the drilling of the well, which is then or thereafter becomes the unit well. Separate units
                            may be created for separate stratum or strata of brine even though the areas thereof overlap; and the creation of a unit as to one
                            strata or stratum shall not exhaust the right of Lessee (even as to the same well) to create different or additional units for other
                            strata or stratum of the same or other minerals. A unit established hereunder shall be valid and effective for all purposes of this
                            lease even though there may be land or mineral, royalty, and/or leasehold interests in land within the unit which are not pooled or
                            unitized, or even though there may be a failure of the leasehold title (in whole or in part) to any tract or interest therein included
                            in a pooled unit.  Any unit created by Lessee hereunder may also be revised so as to conform with an order of a Regulatory Body issued
                            after said unit was originally established; such revision shall be effective as of the effective date of such order. Also, any pooled
                            unit designated by Lessee in accordance with the terms hereof may be dissolved by Lessee by instrument filed for record in the
                            appropriate Records of the County in which the land or interests therein are situated at any time prior to the commencement of
                            drilling or after the completion of a dry hole or the cessation of production on said unit It is specifically understood and agreed
                            that Lessor does hereby grant to Lessee the right and authority to consent to or otherwise comply with any order, rule or regulation
                            of any Regulatory Body of the State of Arkansas or of the United States having jurisdiction with regard to the creation of any pool,
                            unit or district for the production and injection of brine which shall be binding upon Lessor without Lessor's further consent,
                            provided only that Lessee shall never decrease the amount of the annual payments herein specified to be paid in lieu of brine royalty
                            which would otherwise have been required to have been paid in the absence of such pool, unit or district. Notwithstanding the limitation
                            that a production unit for brine cannot exceed 3200 acres, Lessee, as the agent for Lessor, is granted the right to execute all necessary
                            ratifications of any unit agreement and/or unit operating agreements as may be necessary to obtain the approval of the Arkansas Oil & Gas
                            Commission for the creation of a field-wide unit without regard to the size of such field-wide unit.
                        </Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]} wrap={false}>
                        <Text style={[styles.fontNormal, { width: '7%' }]}>§10.</Text>
                        <Text style={[styles.fontNormal, { width: '93%' }]}>
                            Lessee shall have the right to construct, erect, maintain, replace and use on the land mentioned in the foregoing §1, all
                            storage tanks, separators, pipelines, buildings, pumps, shafts, hoists, machinery, boilers, engines, electric lines, telephone
                            and telegraph lines, roads, bridges, and other equipment reasonably necessary for conducting, on the land covered by this lease,
                            operations hereunder of any nature whatsoever . Lessee shall have the right to remove all equipment, materials, and supplies placed
                            upon the leased premises at any time while this lease is in effect as to the land on which such material, equipment and supplies are
                            located, or within a period of two years after this lease has terminated for any reason with respect to the land on which such materials,
                            equipment and supplies is or are located. Lessor grants to Lessee the right to lay, maintain, repair and replace, from time to time,
                            upon the land covered by this lease, a pipeline or pipelines for the purpose of transporting brine and associated gas onto and across
                            the land covered by this Lease.
                        </Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]} wrap={false}>
                        <Text style={[styles.fontNormal, { width: '7%' }]}>§11.</Text>
                        <Text style={[styles.fontNormal, { width: '93%' }]}>
                            When requested by Lessor in writing, Lessee shall bury any pipe below plow depth. Lessee agrees to pay all damages to timber and growing
                            crops on the leased premises caused by its operations. Lessee further agrees to pay to surface owner annually $50.00 for each surface acre
                            hereof which Lessee has used during the previous year in such manner that surface owner was thereby prevented from having the normal use
                            thereof; provided, however, Lessee's failure to make payment of such surface rental shall not be cause for termination of Lessee's rights
                            hereunder but shall entitle owner to recover from Lessee any such rental so due. Further, it is specifically agreed that if Lessee shall
                            have constructed or placed roads, pipelines or power lines upon land covered by this Lease and Lessee has ceased to make any of the payments
                            required to be made in §4 or  hereof, then Lessee may, nevertheless, execute a partial release of this lease as provided under the terms of
                            §4 or §6 hereof which partial release shall retain to Lessee the right to continue to hold for such surface use purposes only the land then
                            being so used for such road, pipeline or power line purposes by continuing to make such above specified annual surface rental payments to Lessor
                            which payments shall be continued only as long as said surface is so used by Lessee. Notwithstanding any other provision of this §11, Lessee shall
                            not drill any well or construct any structure, other than a pipeline, within 200 feet of any dwelling house now upon land affected by this Lease.
                            Lessee recognizes that the lands covered by this Lease may be owned by a third party (“Surface Owner”). Lessee agrees to obtain all consents
                            required for surface access and surface use and to comply with all provisions within any surface use agreement held by the Surface Owner or any other party.

                        </Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]} wrap={false}>
                        <Text style={[styles.fontNormal, { width: '7%' }]}>§12.</Text>
                        <Text style={[styles.fontNormal, { width: '93%' }]}>
                            If the estate of either party hereto is assigned or sublet, and the privilege of assigning or subletting in whole or in part is expressly allowed,
                            the covenants hereof shall extend to the sublessees, successors and assigns of the parties; and in the event of an assignment or subletting by Lessee,
                            Lessee shall be relieved and discharged as to the leasehold rights so assigned or sublet from any liability to Lessor thereafter accruing under any of
                            the covenants or conditions of this lease. No change in the ownership of the land or mineral interests covered by this lease or in the ownership of
                            any royalty, however accomplished, shall operate to enlarge the obligations or diminish the rights of Lessee or require separate measuring or
                            installation of separate measuring tanks by Lessee. Notwithstanding any actual or constructive knowledge of or notice to Lessee, no change in
                            the ownership of land, or of any mineral interest, covered by this lease, or of the right to receive any payment to be made under the foregoing
                            §4, or of any interest therein, by reason of death, or conveyance, or in any other manner, shall be binding on Lessee until ninety (90) days after
                            Lessee has been furnished written notice thereof, together with the original or certified copies of all documents and affidavits necessary to
                            establish the change in ownership involved.

                        </Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]} wrap={false}>
                        <Text style={[styles.fontNormal, { width: '7%' }]}>§13.</Text>
                        <Text style={[styles.fontNormal, { width: '93%' }]}>
                            Lessor hereby warrants and agrees to defend the title to the land covered by this lease, but if the interest of Lessor covered by this Lease is
                            expressly stated to be less than the entire fee simple mineral estate, Lessor's warranty shall be limited to the interest so stated. Lessee may
                            purchase or lease the rights of any person claiming any interest in the land covered by this lease and exercise such rights as may be obtained
                            thereby and Lessee shall not suffer any forfeiture nor incur any liability to Lessor by reason thereof. Lessee shall have the right at any
                            time to pay for Lessor, taxes or any indebtedness secured by a mortgage or other lien on said land, in the event of default of payment by
                            Lessor, and be subrogated to the rights of the holder thereof.  Any such payment made by Lessee for Lessor may be deducted from any amounts
                            of money which may become due Lessor under this lease.

                        </Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]} wrap={false}>
                        <Text style={[styles.fontNormal, { width: '7%' }]}>§14.</Text>
                        <Text style={[styles.fontNormal, { width: '93%' }]}>
                            So long as each payment which Lessee is obligated to make in accordance with §4 or §6 hereof is made, Lessee shall not be obligated,
                            whether or not there has previously been production from or injection into land covered hereby or on acreage pooled therewith (or any
                            part thereof) or from or into any well located within one-half (1/2) mile of the land covered hereby, either expressly or impliedly,
                            to drill or operate on land covered by this lease any well for the production of brine or for the injection of brine into said land.

                        </Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]} wrap={false}>
                        <Text style={[styles.fontNormal, { width: '7%' }]}>§15.</Text>
                        <Text style={[styles.fontNormal, { width: '93%' }]}>
                            The term “brine” as used in this lease shall mean subterranean salt water and all other chemical substances produced with or extracted
                            therefrom, except brine produced incidentally to the production of oil or gas, unless such brine is saved or sold for the purpose of
                            extracting the chemical substances therein.

                        </Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]} wrap={false}>
                        <Text style={[styles.fontNormal, { width: '7%' }]}>§16.</Text>
                        <Text style={[styles.fontNormal, { width: '93%' }]}>
                            In the event the Lessor at any time considers that Lessee is not fulfilling its express or implied obligations (including the payment
                            of royalties due hereunder), Lessor shall notify Lessee in writing of the facts relied upon as constituting a breach of said obligations;
                            and Lessee shall have sixty (60) days after receipt of such notice in which to take such action as is then legally necessary to comply with
                            the requirements hereof. The service of said notice and the lapse of sixty (60) days without Lessee meeting or commencing to meet the alleged
                            breaches shall be a condition precedent to any action by Lessor for any cause hereunder. It is provided, however, that after production of
                            brine has been obtained from the land covered hereby or land pooled therewith (or any part thereof), this lease shall not be subject to
                            forfeiture or loss, either in whole or in part, for failure to comply with the express or implied obligations of this contract, except after
                            final judicial ascertainment of such failure and after Lessee has been given a period of sixty (60) days after such final judicial ascertainment
                            to prevent such loss or forfeiture by complying with and discharging the obligations as to which Lessee has been judicially determined to be in default.

                        </Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]} wrap={false}>
                        <Text style={[styles.fontNormal, { width: '7%' }]}>§17.</Text>
                        <Text style={[styles.fontNormal, { width: '93%' }]}>
                            The requirements hereof shall be subject to any State and/or Federal law or order regulating operations on or under the land.
                            It is further agreed that should Lessee be prevented from complying with any express or implied covenants of this lease, from conducting
                            drilling or reworking operations thereon, or from producing brine therefrom by reason of scarcity or inability after effort made in good
                            faith to obtain equipment or material or authority to use same, or by failure of carriers to transport or furnish facilities for transportation,
                            or by operation of force majeure, any Federal or State law, or any order, rule or regulation of governmental authority, or by any other cause
                            beyond Lessee's control, then while so prevented, Lessee's obligation to comply with such covenants shall be suspended; and Lessee shall not
                            be liable for damages for failure to comply therewith; and this lease shall be extended while and so long as Lessee is prevented by any such
                            cause from conducting drilling or reworking operations on or from producing brine from the leased premises; and the time while Lessee is so
                            prevented shall not be counted against Lessee; provided, however that if such suspension occurs, Lessee shall pay or tender the appropriate
                            annual sum in payment of rental or in lieu of royalty as provided in §4 or §6 thereof.

                        </Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]} wrap={false}>
                        <Text style={[styles.fontNormal, { width: '7%' }]}>§18.</Text>
                        <Text style={[styles.fontNormal, { width: '93%' }]}>
                            Lessee shall also have the right to produce, remove, and appropriate such oil, gas and other minerals as may be necessarily produced incidentally
                            with the production of salt water (brine); provided, however, that <Text style={[{ fontFamily: 'Helvetica-Bold' }]}>three-sixteenths (<sup>3</sup>/<sub>16</sub><sup>ths</sup>)</Text> of the value of all such oil, gas, and other minerals
                            produced, saved, and marketed by Lessee shall be paid as royalty thereon to those persons entitled thereto based upon the spacing pattern therefor as
                            established by the Arkansas Oil and Gas Commission or alternatively upon the basis of the regular governmental quarter section upon which such well is
                            located if no spacing pattern has otherwise has been established.

                        </Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]} wrap={false}>
                        <Text style={[styles.fontNormal, { width: '7%' }]}>§19.</Text>
                        <Text style={[styles.fontNormal, { width: '93%' }]}>
                            This lease and all provisions thereof shall be applicable to and binding upon the parties and their respective heirs, successors and assigns.
                            If anyone or more of the persons named as Lessor does or do not execute this lease, it shall nevertheless be binding upon each of the persons
                            executing it.

                        </Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]}>
                        <Text style={[styles.fontNormal, { width: '7%' }]}>§20.</Text>
                        <Text style={[styles.fontNormal, { width: '93%' }]}>
                            And for the consideration aforesaid, each of the undersigned persons does hereby join in this instrument for all purposes and does hereby
                            release and relinquish unto the Lessee herein all of his and/or her rights of curtesy and/or dower and homestead in and to the
                            above-described property to the extent necessary to effectuate the purposes of this instrument.

                        </Text>
                    </View>

                    <View style={[styles.mb1, { flexDirection: 'row' }]}>
                        <Text style={[styles.fontNormal, { width: '7%' }]}>§21.</Text>
                        <Text style={[styles.fontNormal, { width: '93%' }]}>
                            In the event that Lessor, during the primary term of this lease, receives a bona fide offer which Lessor is willing to accept from
                            any party offering to purchase from Lessor a lease covering any or all of the substances covered by this lease and covering all
                            or a portion of the land described herein, with the lease becoming effective upon expiration of this lease, Lessor hereby agrees
                            to notify Lessee in writing of said offer immediately, including in the notice the name and address of the offer or, the price
                            offered and all other pertinent terms and conditions of the offer. Lessee, for a period of fifteen (15) days after receipt of the
                            notice, shall have the prior and preferred right and option to purchase the lease or part thereof or interest therein, covered by
                            the offer at the price and according to the terms and conditions specified in the offer. Should Lessee elect to lease said interest,
                            Lessor shall be obligated to execute and deliver such new lease.

                        </Text>
                    </View>

                    <View style={[styles.mb1]}>
                        <Text style={[styles.fontNormal, styles.mt4, styles.text, styles.bold, { textAlign: 'center', marginBottom: '4rem' }]}>
                            THE REST OF THIS PAGE IS INTENTIONALLY BLANK
                        </Text>
                        <Text style={[styles.fontNormal, styles.mt1, styles.text, styles.bold, styles.center]}>
                            [ACKNOWLEDGMENTS AND SIGNATURES ARE DISPLAYED IN THE NEXT PAGES]
                        </Text>
                    </View>

                </Page>

                {this?.props?.leaseProps?.acknowledgements?.length > 0 && (
                    <Page size="LEGAL" style={styles.page} wrap={true}>
                        <View wrap={true}>
                            <Text style={[styles.fontNormal, styles.negativeindent, styles.mt3, styles.sbTitle, styles.bold, styles.text]}>
                                IN WITNESS WHEREOF,{' '}
                                <Text style={[styles.fontNormal]}>
                                    this instrument is executed as of the date hereinbefore first mentioned, which date shall be the basis for ascertaining
                                    the first and each succeeding anniversary date of the execution of this lease.
                                </Text>
                            </Text>
                            <View
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                }}
                            >
                                {this.displaySignatureBlocks()}
                            </View>
                        </View>
                        <View wrap={true} style={styles.mt2}>
                            <Text style={[styles.acknowledgementHeading, styles.mt2, styles.underlined, styles.bold]}>ACKNOWLEDGMENT</Text>
                            {this.displayAcknowledgements()}
                        </View>
                        <Text style={styles.pageNumbers} render={({ pageNumber }) => `${pageNumber}`} fixed={true} />
                    </Page>

                )}

                <Page size="LEGAL" style={styles.page}>
                    <Text style={[styles.exhibitHeading, styles.bold]}>Exhibit A</Text>
                    <Text style={[{ fontSize: '10pt' }, styles.mt2]}>
                        Attached to and made part of that certain Paid Up Oil and Gas Lease dated{' '}
                        <Text style={[styles.bold]}>{this?.props?.leaseProps?.effectiveDateDo}</Text> day
                        of{' '}
                        <Text style={[styles.bold]}>
                            {this?.props?.leaseProps?.effectiveDateMonthName},{' '}
                            {this?.props?.leaseProps?.effectiveDateYear}
                        </Text>
                        , by and between{' '}
                        <Text style={[styles.bold]}>{this?.props?.leaseProps?.ownersOnDocument}</Text>, as Lessor,
                        and{' '}
                        <Text style={[styles.bold, { fontSize: '9pt' }]}>
                            {this?.props?.leaseProps?.lesseeName}
                        </Text>
                        , as Lessee.
                    </Text>
                    {this?.props?.leaseProps?.legalDescription?.length > 1000 &&
                        <>
                            <Text style={[styles.mt2, { fontSize: '10pt' }, styles.bold]}>LEGAL DESCRIPTION:</Text>
                            <Text style={[styles.fontNormal, styles.mt1, styles.text, { fontSize: '10pt' }]}>
                                {this?.props?.leaseProps?.legalDescription}
                            </Text>
                        </>
                    }

                    <Text style={styles.pageNumbers} render={({ pageNumber }) => `${pageNumber}`} fixed={true} />
                    {(this?.props?.leaseProps?.adHocClauses?.length > 0 ||
                        this?.props?.leaseProps?.additionalProvisions?.length > 0) && (
                            <View wrap={true}>
                                <Text style={[styles.mt2, { fontSize: '10pt' }, styles.bold]}>ADDITIONAL TERMS AND PROVISIONS:</Text>
                                <Text style={[{ fontSize: '10pt' }, styles.mt1]}>
                                    Notwithstanding anything contained in this lease to the contrary, the following provisions shall control and prevail over
                                    any other:{' '}
                                </Text>

                                {this.additionalProvisions()}
                                {this.adhocProvisions()}

                                <Text style={[{ fontSize: '10pt' }, styles.mt4, styles.text, styles.bold]}>
                                    ____________________________________
                                </Text>
                                <Text style={[{ fontSize: '10pt' }, styles.mt1, styles.text, styles.bold]}>{this?.props?.leaseProps?.ownersOnDocument || 'Lessor'}</Text>

                                {/* <Text style={styles.pageNumbers} render={({ pageNumber }) => `${pageNumber}`} fixed={true} /> */}
                            </View>
                        )}
                </Page>
            </Document>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/BrineTemplates/SaltwerxBrineLeaseTemplate.tsx